(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset1', {
            parent: 'account',
            url: '/reset/customerEmailChange?key',
            data: {
                authorities: []
            },
            views: {
                'logincontent@': {
                    templateUrl: 'app/account/reset/customerEmailChange/reset.finish.html',
                    controller: 'ResetFinish1Controller',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('userProfile');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
